module.exports = __webpack_public_path__ + "img/fa-file-lines.33c33cdc.svg";